import { render, staticRenderFns } from "./jilu.vue?vue&type=template&id=0272e796&scoped=true&"
import script from "./jilu.vue?vue&type=script&lang=js&"
export * from "./jilu.vue?vue&type=script&lang=js&"
import style0 from "./jilu.vue?vue&type=style&index=0&id=0272e796&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0272e796",
  null
  
)

export default component.exports